// apps/website/src/components/PageViewTracker.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '@dopomogai/agent-kit';

export function PageViewTracker() {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track('page_view', { path: location.pathname + location.search });
  }, [location, analytics]);

  return null;
}

export default PageViewTracker;
